import { Price } from '@/components/Price'
import type { CurrencyCode } from '@/services/graphql/generated'
import { Text } from 'ui/src/components/Text/Text'
import { xStack } from 'ui/src/patterns/stack'

type Props = {
  amount: number
  crossedOutAmount?: number
  currencyCode: CurrencyCode
  title: string
  subTitle: string
  priceExplanation: string
}

export function PriceBreakdown({ amount, crossedOutAmount, currencyCode, title, subTitle, priceExplanation }: Props) {
  const showCrossedOverAmount = crossedOutAmount !== undefined && crossedOutAmount > amount

  return (
    <div>
      <div className={xStack({ justifyContent: 'space-between' })}>
        <Text>{title}</Text>
        <Price
          amount={showCrossedOverAmount ? crossedOutAmount : amount}
          currencyCode={currencyCode}
          reducedAmount={showCrossedOverAmount ? amount : undefined}
        />
      </div>

      <div className={xStack({ justifyContent: 'space-between' })}>
        <Text size="xs" color="textSecondary">
          {subTitle}
        </Text>
        <Text size="xs" color="textSecondary">
          {priceExplanation}
        </Text>
      </div>
    </div>
  )
}
